import * as React from 'react'
import { useIntl } from 'react-intl'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { Box } from '@mui/system'
import { LinearProgress } from '@mui/material'
import { BoldText } from '../../../../layouts/TextStyles'
import { courseSubjectApiSlice } from '../../../../features/course/courseSubjectSlice'
import { ui } from '../../../../utils/uiTokens'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}))

export interface DialogTitleProps {
    id: string
    children?: React.ReactNode
    onClose: () => void
}

function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props

    return (
        <DialogTitle
            sx={{ m: 0, p: 2 }}
            {...other}
        >
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    )
}

interface Props {
    courseSubjectId: number
}

const LessonLinksDialog: React.FC<Props> = ({ courseSubjectId }) => {
    const { formatMessage } = useIntl()
    const [open, setOpen] = React.useState(false)
    const { data: links = [], isFetching } =
        courseSubjectApiSlice.useGetSubjectLinksQuery(+courseSubjectId, {
            skip: !open,
        })

    const handleClickOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
    }

    return (
        <div>
            <Button
                variant="contained"
                onClick={handleClickOpen}
            >
                {formatMessage({ id: 'lessonLinks' })}
            </Button>

            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                maxWidth={'md'}
                fullWidth
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={handleClose}
                >
                    {formatMessage({ id: 'lessonLinks' })}
                </BootstrapDialogTitle>

                <DialogContent dividers>
                    {isFetching && <LinearProgress />}

                    {links.length ? (
                        links.map((link, index) => (
                            <Box
                                m={2}
                                key={index}
                            >
                                {/* <Box mb={1}>
                                    <BoldText>{link.title}</BoldText>
                                </Box>

                                <Box mb={1}>
                                    {formatMessage({ id: 'lessonLink' })}
                                </Box>

                                <Box
                                    sx={{
                                        mb: 1,
                                        padding: '16px',
                                        background: ui.surface,
                                        borderRadius: 1,
                                    }}
                                >
                                    <a href="www.youtube.com">
                                        {link.lessonLink}
                                    </a>
                                </Box>

                                <Box mb={1}>
                                    {formatMessage({ id: 'lessonComment' })}
                                </Box>

                                <Box
                                    sx={{
                                        mb: 1,
                                        padding: '16px',
                                        background: ui.surface,
                                        borderRadius: 1,
                                    }}
                                >
                                    {link.lessonComment}
                                </Box> */}
                            </Box>
                        ))
                    ) : (
                        <BoldText>{formatMessage({ id: 'noData' })}</BoldText>
                    )}
                </DialogContent>
            </BootstrapDialog>
        </div>
    )
}

export default LessonLinksDialog
